<template>
  <div id="DocumentLimitTransactionButton" class="sun not-full">
    <button>
      <!--Agree-->
      <div class="check-section">
        <div class="p-a w-24px h-24px bor-100 c-we t-18px r-8px tn-500ms"
             :class="{'b-D7E1EA': !isComplete, 'b-1BAAF1': isComplete }"
             style="position: absolute;">
          <img class="cen" src="@/assets/images/agreements/check.svg" alt="arrow-down"/>
        </div>
      </div>
      <!--Title-->
      <div class="title-section">
        <b>{{title}}</b>
      </div>
      <!--Arrow-->
      <div class="arrow-section">
        <img
             src="@/assets/images/agreements/arrow-down.svg"
             alt="arrow-down"
             :style="{'transform': isCollapse?'rotate(180deg)':null}"/>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: 'DocumentLimitTransactionButton',
  props: ['title', 'isComplete', 'isCollapse'],
  data: function () {
    return {
    }
  },
  computed: {},
  created() {
  },
  destroyed() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
  #DocumentLimitTransactionButton {
    button {
      width: 100%;
      height: 60px;
      border-radius: 4px;
      box-shadow: 0 6px 16px 0 rgba(32, 35, 36, 0.08);
      background-color: #f4faff;
      margin-top: 20px;
      .check-section {
        display: inline-block;
        width: 52px;
        height: 100%;
        float: left;
      }
      .title-section {
        display: inline-block;
        width: calc(100% - 106px);
        height: 100%;
        color: #8a94a2;
        text-align: left;
        font-size: 15px;
        line-height: 60px;
        padding-left: 8px;
        float: left;
        letter-spacing: -0.19px;
        font-weight: 900;
      }
      .arrow-section {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 54px;
        height: 100%;
        img {
          transition-property: all;
          transition-duration: 500ms;
        }
      }
    }
  }
</style>
